import Cookies from "js-cookie";
import environment from "../../environment";

// Tokens are kept in both localStorage (read by http.service for the
// Authorization header) and a cookie (read by PrivateRoutes) so the two
// existing consumers of "is the donor logged in" stay in sync.
export const setAuthTokens = ({ accessToken, refreshToken } = {}) => {
  if (accessToken) {
    localStorage.setItem(environment.TOKEN_KEY, accessToken);
    Cookies.set("token", accessToken);
  }
  if (refreshToken) {
    localStorage.setItem(environment.REFRESH_TOKEN_KEY, refreshToken);
  }
};

export const getAccessToken = () => localStorage.getItem(environment.TOKEN_KEY);

export const getRefreshToken = () =>
  localStorage.getItem(environment.REFRESH_TOKEN_KEY);

export const clearAuthTokens = () => {
  localStorage.removeItem(environment.TOKEN_KEY);
  localStorage.removeItem(environment.REFRESH_TOKEN_KEY);
  Cookies.remove("token");
};

// The multi-step "verify account" and "forgot password" flows need to carry
// the donor's email (and, later, the verified code) across pages/refreshes.
export const setPendingVerificationEmail = (email) =>
  sessionStorage.setItem(environment.PENDING_VERIFICATION_EMAIL_KEY, email);

export const getPendingVerificationEmail = () =>
  sessionStorage.getItem(environment.PENDING_VERIFICATION_EMAIL_KEY);

export const clearPendingVerificationEmail = () =>
  sessionStorage.removeItem(environment.PENDING_VERIFICATION_EMAIL_KEY);

export const setResetPasswordEmail = (email) =>
  sessionStorage.setItem(environment.RESET_PASSWORD_EMAIL_KEY, email);

export const getResetPasswordEmail = () =>
  sessionStorage.getItem(environment.RESET_PASSWORD_EMAIL_KEY);

export const setResetPasswordCode = (code) =>
  sessionStorage.setItem(environment.RESET_PASSWORD_CODE_KEY, code);

export const getResetPasswordCode = () =>
  sessionStorage.getItem(environment.RESET_PASSWORD_CODE_KEY);

export const clearResetPasswordFlow = () => {
  sessionStorage.removeItem(environment.RESET_PASSWORD_EMAIL_KEY);
  sessionStorage.removeItem(environment.RESET_PASSWORD_CODE_KEY);
};
